import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {WatchGroup} from '@acng/frontend-relativity';
import {ARRAY, BOOLEAN, ENUM, INTEGER, OBJECT, guard} from '@acng/frontend-rubicon';
import {URLSearchParams} from '@acng/frontend-bounty/net/url.js';
import {size} from '@acng/frontend-bounty/std/array.js';

import {Actor} from '../../layout/context/list.js';
import {cdn} from '../../core/service/cdn.js';
import {ListItem, compile} from '../service/template.js';
import {user} from '../../user/user.js';
import {STYLE_EMPTY, swapClass} from 'acng/layout/service/style.js';
import {STYLE_INIT} from 'acng/layout/style/flags.js';
import {ctxAmateur} from 'acng/amateurPool/context/amateur.js';
import {ctxSearchParams} from 'acng/core/context/search-params.js';

/**
 * @group DOM Attribute
 */
export const MOVIE_LIST = 'movie-list';

const MOVIE_LIST_RESPONSE_DATA = /* @__PURE__*/ OBJECT({
  data: /* @__PURE__ */ ARRAY(INTEGER),
  total: INTEGER,
  bl: BOOLEAN,
});

AttributeSetup(MOVIE_LIST, (name) => {
  const watch = WatchGroup(`[${name}]`, ctxAmateur, ctxSearchParams);
  const provideList = Actor();
  const limit = 64;

  AttributeLink(name, (element, movieList) => {
    watch(element, (element, [amateur, searchParams]) => {
      let isEmpty = false;

      ASSERT: if (!amateur)
        guard(
          movieList,
          ENUM(
            /**
             * @type {const}
             */ (['top', 'new', 'classics', '']),
          ),
        );
      const type = amateur ? '' : `/${movieList || 'top'}`;

      const filter = JSON.stringify({
        nickname: amateur?.nickname,
        search: searchParams.get('search') ?? undefined,
        categories: searchParams
          .get('category')
          ?.split(',')
          .filter((v) => !!v),
      });

      const fsk = `${user.getListFsk()}`;

      /**
       * @param {number} offset
       */
      const more = async (offset) => {
        if (isEmpty || offset % limit) {
          return [];
        }

        const params = new URLSearchParams({
          offset: `${offset}`,
          limit: `${limit}`,
          fsk,
          filter,
        });

        const data = await cdn(`/api/movie/lists${type}?${params}`);
        ASSERT: guard(data, MOVIE_LIST_RESPONSE_DATA);
        const {data: list, bl: blacklist} = data;

        isEmpty = swapClass(element, STYLE_EMPTY, !offset && !size(list));
        swapClass(element, STYLE_INIT, false);

        //TODO should no longer be needed
        if (isEmpty && !blacklist) {
          const params = new URLSearchParams({
            limit: '16',
            fsk,
            filter: JSON.stringify({nickname: amateur?.nickname}),
          });

          const data = await cdn(`/api/movie/lists?${params}`);
          ASSERT: guard(data, MOVIE_LIST_RESPONSE_DATA);

          return data.data;
        }

        return list;
      };

      swapClass(element, STYLE_INIT, true);
      provideList(element, more, ListItem);
    });
  });

  return compile;
});
